<template>
  <div id="app" >
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style scoped lang="scss">

#app {
  // font-family:"Noto Sans CJK SC", "Source Han Sans CN";
  font-family:"Microsoft YaHei";
  font-family:arial;
  font-family:  “Microsoft YaHei”, “微软雅黑”;
  
  // font-family:Georgia,Serif,Noto Sans CJK SC, Source Han Sans CN;
		// font-family:'SimHei';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>



// WEBPACK FOOTER //
// src/App.vue